export const stepTransition = {
	duration: 0.32,
	ease: [0.22, 1, 0.36, 1],
};

export const stepVariants = {
	initial: { opacity: 0, y: 18 },
	animate: { opacity: 1, y: 0 },
	exit: { opacity: 0, y: -12 },
};

export const sectionVariants = {
	initial: { opacity: 0 },
	animate: {
		opacity: 1,
		transition: {
			delayChildren: 0.08,
			staggerChildren: 0.055,
		},
	},
};

export const itemVariants = {
	initial: { opacity: 0, y: 12 },
	animate: {
		opacity: 1,
		y: 0,
		transition: {
			duration: 0.28,
			ease: [0.22, 1, 0.36, 1],
		},
	},
};

export const optionTap = { scale: 0.985 };
export const optionHover = { y: -1 };
